import { IllustrationCards } from './IllustrationCards'

import type { IllustrationCardProps } from './IllustrationCard'
import type { SanityBenefitCard } from 'src/types/HomepageContent'

export interface BenefitsCardsSection {
  benefitsCardsSection: SanityBenefitCard[]
  title: string
}

export const BenefitCards = ({ title, benefitsCardsSection }: BenefitsCardsSection) => {
  const names = ['roastery-new', 'subscription-new', 'preparation-new'] as const

  const cards: IllustrationCardProps[] = names.map((name, index) => {
    const card = benefitsCardsSection[index]
    return {
      name,
      headlineText: card?.benefitCardTitle ?? '',
      text: card?.benefitCardText ?? '',
    }
  })

  return <IllustrationCards cards={cards} bannerHeadLineText={title} />
}
